import Button, { type ButtonProps, type ButtonVariantProps } from '@ui-kit/components/Button';
import type { ComponentProps } from 'react';
import { Link } from 'react-router';

type AnchorButtonProps = ButtonVariantProps &
  Omit<ComponentProps<'a'>, 'children' | keyof ButtonVariantProps>;

export const AnchorButton = ({
  className,
  disabled,
  loading,
  variant,
  size,
  href,
  ...props
}: AnchorButtonProps) => (
  <Button
    {...({
      asChild: true,
      className,
      disabled: disabled ?? undefined,
      loading,
      variant,
      size,
    } as ButtonProps)}
  >
    {/* eslint-disable-next-line jsx-a11y/anchor-has-content, jsx-a11y/anchor-is-valid */}
    <a href={disabled || loading ? '#' : href} {...props} />
  </Button>
);

type LinkButtonProps = ButtonVariantProps &
  Omit<ComponentProps<typeof Link>, 'children' | keyof ButtonVariantProps>;

export const LinkButton = ({
  className,
  disabled,
  loading,
  variant,
  size,
  to,
  ...props
}: LinkButtonProps) => (
  <Button
    {...({
      asChild: true,
      className,
      disabled: disabled ?? undefined,
      loading,
      variant,
      size,
    } as ButtonProps)}
  >
    {/* eslint-disable-next-line jsx-a11y/anchor-has-content, jsx-a11y/anchor-is-valid */}
    {disabled || loading ? <a href="#" {...props} /> : <Link to={to} {...props} />}
  </Button>
);
